import React from 'react'
import { useSelector } from 'react-redux'
import TopBar from 'components/TopBar'
import { useLocation, useHistory } from 'react-router-dom'
import LogoVerde from 'images/logo-verde.svg'

import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'

import Measure from 'react-measure'
import { makeStyles } from '@material-ui/core/styles'

import TabMenuOption from '../TabMenuOption'
import _ from 'lodash'
import useParams from 'hooks/useParams'

// Menú inferior: categorías = tabs, items = submenús desplegables
const buildMenuOptions = ({ farmOwnerId, farmId, businessId, year }, isAdmin) => [
  {
    id: 0,
    label: 'Planificación',
    route: '/planificacion',
    submenus: [
      {
        label: 'Calendario manejos',
        route: `/${farmOwnerId}/${farmId}/planificacion/calendario-manejos/${year}`,
      },
      {
        label: 'Registro datos lecheros',
        route: `/${farmOwnerId}/${farmId}/planificacion/visitas-prediales/${year}`,
      },
      {
        label: 'Plantillas manejos',
        route: `/${farmOwnerId}/${farmId}/planificacion/plantillas-manejos`,
      },
      { label: 'Base de datos', route: '/planificacion/base-de-datos' },
    ],
  },
  {
    id: 1,
    label: 'Finanzas',
    route: '/finanzas',
    submenus: [
      {
        label: 'Ventas',
        route: `/${farmOwnerId}/${businessId}/finanzas/ventas/${year}`,
      },
      {
        label: 'Compras',
        route: `/${farmOwnerId}/${businessId}/finanzas/compras/${year}`,
      },
      {
        label: 'Estado de resultado',
        route: `/${farmOwnerId}/${businessId}/finanzas/estado-resultado/${year}`,
      },
      {
        label: 'Estado de resultado mensual',
        route: `/${farmOwnerId}/${businessId}/finanzas/estado-resultado-mensual/${year}`,
      },
    ],
  },
  {
    id: 2,
    label: 'Analítica',
    route: '/analitica',
    submenus: [
      {
        label: 'Leche por día',
        route: `/${farmOwnerId}/${farmId}/analitica/leche/dia`,
      },
      {
        label: 'Leche por mes',
        route: `/${farmOwnerId}/${farmId}/analitica/leche/mes`,
      },
      {
        label: 'Insumos y maquinaria',
        route: `/${farmOwnerId}/${farmId}/analitica`,
      },
    ],
  },
  ...(isAdmin
    ? [
        {
          id: 3,
          label: 'Administración',
          route: '/administracion',
          submenus: [
            {
              label: 'Mapas',
              route: `/${farmOwnerId}/${farmId}/mapas/datos-geograficos`,
            },
            {
              label: 'Campos',
              route: `/${farmOwnerId}/administracion-campos`,
            },
            {
              label: 'Empresas',
              route: `/${farmOwnerId}/administracion-empresas`,
            },
            {
              label: 'Lecherías',
              route: `/${farmOwnerId}/unidades-productivas`,
            },
          ],
        },
      ]
    : []),
]

// Menú original (comentado, conservado para referencia)
// const buildMenuOptionsOriginal = ({ farmOwnerId, farmId, businessId, year }) => [
//   { id: 0, label: 'Mapas', route: '/mapas', submenus: [
//     { label: 'Datos Geográficos', route: `/${farmOwnerId}/${farmId}/mapas/datos-geograficos` },
//     { label: 'Datos Climáticos', route: '/mapas/datos-climaticos' },
//   ]},
//   { id: 1, label: 'Planificación', route: '/planificacion', submenus: [
//     { label: 'Base de datos', route: '/planificacion/base-de-datos' },
//     { label: 'Plantillas manejos', route: `/${farmOwnerId}/${farmId}/planificacion/plantillas-manejos` },
//     { label: 'Calendario manejos', route: `/${farmOwnerId}/${farmId}/planificacion/calendario-manejos/${year}` },
//     { label: 'Analisis de suelo', route: '/planificacion/analisis-de-suelo' },
//     { label: 'Ingreso de datos', route: `/${farmOwnerId}/${farmId}/planificacion/visitas-prediales/${year}` },
//   ]},
//   { id: 2, label: 'Balance Forrajero', route: `/${farmOwnerId}/${farmId}/balance-forrajero` },
//   { id: 3, label: 'Finanzas', route: '/finanzas', submenus: [
//     { label: 'Ventas', route: `/${farmOwnerId}/${businessId}/finanzas/ventas/${year}` },
//     { label: 'Compras', route: `/${farmOwnerId}/${businessId}/finanzas/compras/${year}` },
//     { label: 'Estado Resultado', route: `/${farmOwnerId}/${businessId}/finanzas/estado-resultado/${year}` },
//     { label: 'Estado Resultado Mensual', route: `/${farmOwnerId}/${businessId}/finanzas/estado-resultado-mensual/${year}` },
//     { label: 'Depreciación', route: '/finanzas/depreciacion' },
//   ]},
//   { id: 4, label: 'Analítica', route: '/analitica', submenus: [
//     { label: 'Insumos y maquinaria', route: `/${farmOwnerId}/${businessId}/analitica` },
//     { label: 'Leche por día', route: `/${farmOwnerId}/${businessId}/analitica/leche/dia` },
//     { label: 'Leche por mes', route: `/${farmOwnerId}/${businessId}/analitica/leche/mes` },
//     { label: 'Leche mes fijo', route: `/${farmOwnerId}/${businessId}/analitica/leche/mes_fijo` },
//     // { label: 'Indicadores Económicos', route: `/${farmOwnerId}/${businessId}/analitica/indicadores-economicos` },
//     // { label: 'Historial de potreros', route: `/${farmOwnerId}/${businessId}/analitica/historial_potreros` },
//   ]},
// ]

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    minHeight: '48px',
    boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    padding: '0 14px',
    cursor: 'pointer',
    flexShrink: 0,
    userSelect: 'none',
    '&:hover': { opacity: 0.85 },
  },
  menuGroup: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
  },
  brandLogo: {
    height: '22px',
    width: '22px',
    filter: 'brightness(0) invert(1)',
  },
  brandText: {
    color: '#fff',
    fontWeight: 700,
    fontSize: '0.95rem',
    letterSpacing: '0.08em',
  },
  homeLogoWrap: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  homeLogo: {
    height: '26px',
    filter: 'brightness(0) invert(1)',
  },
  containerContent: {
    paddingTop: '1em',
    paddingBottom: '56px',
    maxWidth: '1800px',
    paddingLeft: '1em',
    paddingRight: '1em',
    margin: 'auto',
  },
}))

export default function Template({ children }) {
  const [tabBarWidth, setTabBarWidth] = React.useState(1179)

  const routeParams = useParams()
  const user = useSelector((state) => state.user)
  const isAdmin = user?.is_admin || user?.is_super_admin
  const history = useHistory()

  const menuOptions = buildMenuOptions(routeParams, isAdmin)
  const classes = useStyles()

  let location = useLocation()

  // En el home (/:farmOwnerId/:farmId) no se muestra el menú inferior
  const isHome = /^\/\d+\/\d+$/.test(location.pathname)

  const getIdFromPath = (options, path) => {
    const option = _(options).find((m) => {
      // eslint-disable-next-line no-useless-escape, prettier/prettier
      const pathRegEx = new RegExp(_(m.route).split('/').value().join('/'), 'g')

      return pathRegEx.test(path)
    })
    return option ? option.id : null
  }
  const tabId = getIdFromPath(menuOptions, location.pathname) || 0

  return (
    <div className={classes.root}>
      <TopBar />
      <Measure
        bounds
        onResize={(contentRect) => {
          setTabBarWidth(contentRect.bounds.width)
        }}
      >
        {({ measureRef }) => (
          <div ref={measureRef}>
            <div className={classes.containerContent}>{children}</div>

            <AppBar position='fixed' className={classes.appBar}>
              {isHome ? (
                <div className={classes.homeLogoWrap}>
                  <img src={LogoVerde} alt='ALBA' className={classes.homeLogo} />
                </div>
              ) : (
                <div className={classes.menuGroup}>
                  <div
                    className={classes.brand}
                    onClick={() =>
                      history.push(
                        `/${routeParams.farmOwnerId}/${routeParams.farmId}`,
                      )
                    }
                  >
                    <img src={LogoVerde} alt='ALBA' className={classes.brandLogo} />
                    <span className={classes.brandText}>ALBA</span>
                  </div>
                  <Tabs
                    value={tabId}
                    aria-label='site navigator'
                    scrollButtons='auto'
                    variant='standard'
                  >
                    {menuOptions.map(({ label, route, submenus }, index) => (
                      <TabMenuOption
                        key={index}
                        label={label}
                        route={route}
                        submenus={submenus}
                      />
                    ))}
                  </Tabs>
                </div>
              )}
            </AppBar>
          </div>
        )}
      </Measure>
    </div>
  )
}
